import React from 'react';
import PropTypes from 'prop-types';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    margin: '60px 0',
    alignItems: 'center',
    flexDirection: 'column',
  },
  emptyStateContainer: {
    textAlign: 'center',
    width: '300px',
  },
  searchIcon: {
    color: colors.blue3,
    fontSize: '90px',
    marginBottom: '15px',
    display: 'block',
    margin: '0 auto',
    '@media (max-width: 600px)': {
      fontSize: '60px',
    },
  },
  mainText: {
    fontSize: '28px',
    color: colors.textColor,
    margin: 0,
    marginBottom: '5px',
    fontWeight: 'bold',
    '@media (max-width: 600px)': {
      fontSize: '24px',
    },
  },
  subText: {
    fontSize: '20px',
    color: colors.textColor,
    margin: 0,
    lineHeight: 1.2,
    '@media (max-width: 600px)': {
      fontSize: '18px',
    },
  },
}));

const EmptyState = ({ message, isStubPage, subTextMessage }) => {
  const classes = useStyles();

  return (
    <div className={classes.emptyState}>
      <div className={classes.emptyStateContainer}>
        {!isStubPage && <SearchOutlinedIcon fontSize="large" className={classes.searchIcon} />}
        <p className={classes.mainText}>{message}</p>
        {!isStubPage && <p className={classes.subText}>{subTextMessage}</p>}
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  message: PropTypes.string,
  isStubPage: PropTypes.bool,
  subTextMessage: PropTypes.string,
};

EmptyState.defaultProps = {
  isStubPage: false,
};

export default EmptyState;
